module.exports = __webpack_public_path__ + "static/media/whatsapp.53bdc4a5.svg";